import { useRouter } from 'next/router';

import { getServiceOSEmailVerificationQueryParams } from '../utils/getServiceOSEmailVerificationQueryParams';
import { ServiceOSGlobalSettings } from '../utils/getServiceOSGlobalSettings';

export function useServiceOSEmailVerificationRedirects(
  serviceOSGlobalSettings: ServiceOSGlobalSettings
) {
  const router = useRouter();

  if (typeof window === 'undefined') {
    return;
  }

  if (
    `${router.locale}${router.asPath}`.includes(serviceOSGlobalSettings.emailVerificationPageUrl)
  ) {
    return;
  }

  const { searchParams } = getServiceOSEmailVerificationQueryParams(serviceOSGlobalSettings);

  if (!searchParams) {
    return;
  }

  const url = new URL(serviceOSGlobalSettings.emailVerificationPageUrl, window.location.origin);
  url.search = searchParams.toString();

  router.push(url.toString());
}
